import React, { Fragment } from "react";

export default () => {
  const speciesData = [
    {  option: "Whitetailed Deer", value: "Whitetailed Deer" },
    {  option: "Elk", value: "ELK" },
    {  option: "Sika Deer", value: "Sika Deer" },
    {  option: "Red Deer", value: "Red Deer" },
    {  option: "Fallow Deer", value: "Fallow Deer" },
    {  option: "Other", value: "Other" }
  ];

  return (
    <Fragment>
      <option />
      {speciesData.map((l, i) => (
        <option key={i} value={l.value}>
          {l.option}
        </option>
      ))}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/wizardSection/renderSpeciesOptions.jsx